export default "__VITE_ASSET__3tFnzTLm__"